import { gql, useQuery } from '@apollo/client'
import { useEffect, useState } from 'react'

import { config } from '@/config'
import { makeViewModel } from '@/core/architecture'
import { getAccessToken } from '@/core/auth'
import { getBalance, useMetamask } from '@/core/web3/metamask'
import { useWeb3authWalletConnect } from '@/core/web3/web3auth/hooks'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const [balance, setBalance] = useState('')

  const { data, loading, refetch } = useQuery(QUERY)
  const cryptoWalletAddress = data?.artist?.cryptoWallet?.address

  const { artistAuthorizeWalletBySignatureMessage } = useMetamask()

  useEffect(() => {
    if (!cryptoWalletAddress) return

    const t = async () => {
      const balance = await getBalance(cryptoWalletAddress)
      setBalance(balance)
    }
    t()
  }, [cryptoWalletAddress])

  const { web3authWalletLoading } = useWeb3authWalletConnect({
    loading: loading,
    walletAddress: cryptoWalletAddress,
    isArtist: true,
    refetch,
  })

  return {
    state: {
      loading: loading || web3authWalletLoading,
      artistId: data?.artist?.id || config.artistId || '',
      cryptoWallet: {
        displayName: data?.artist?.displayName || '',
        walletAddress: cryptoWalletAddress || '',
        balance,
      },
    },
    actions: {
      connectMetamask: async () => {
        await artistAuthorizeWalletBySignatureMessage()
        await refetch()

        return
      },
      connectWeb3auth: async () => {
        /**
         * web3auth <=> firebase auth連携用のidToken取得
         */
        const idToken = await getAccessToken({ forceUpdateToken: true })
        if (!idToken) throw new Error('get jwtToke failed')

        /**
         * web3auth <=> firebase auth連携
         */
        await import('@/core/web3/web3auth').then(m =>
          m.connectToWeb3Auth(idToken)
        )

        return
      },
    },
  }
})

const QUERY = gql`
  query artistCryptoWallet {
    artist {
      id
      displayName
      cryptoWallet {
        address
      }
    }
  }
`
